//
import Service from '@/services/api/service'
import PaymentConditionModel from '@/models/Purchase/PchPaymentCondition'

//
//import filters from './filters'
//import headers from './headers'

//
export default class extends Service {

    //
    //static filters  = filters
    //static headers  = headers
    
    //
    static model = PaymentConditionModel
}
